var map = {
	"./add.svg": 4159,
	"./boluo.svg": 5278,
	"./guide.svg": 2330,
	"./headText.svg": 2597,
	"./load.svg": 8546,
	"./music.svg": 5623,
	"./pause.svg": 5872,
	"./play.svg": 2408,
	"./right-arrow.svg": 1352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;